import React from 'react'

const HomePage = () => <></>

export default HomePage
